import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';

@Injectable({
  providedIn: 'root',
})
export class CloudFunctionsService {
  constructor(private functions: Functions) {}

  async downloadUserEntriesAsCsv(): Promise<void> {
    const exportFn = httpsCallable(this.functions, 'downloadUserEntriesAsCsv');
    return exportFn().then((result: any) => {
      const blob = new Blob([result.data.csv], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = result.data.filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
  }
}
